module.exports = __webpack_public_path__ + "static/media/carte_mada.41f53d36.svg";